var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-snackbar',{attrs:{"value":true,"color":"black","timeout":"-1","centered":""}},[_vm._v(" Only users with a role of prisoner can view this ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }